import React from "react";
import { Link, useParams } from "react-router-dom";
import { works } from "../utils/data";
import ImageCarousel from "../components/Carousel";

function WorkDetails() {
  const { id } = useParams();
  const work = works.find((item) => item.id === id);

  if (!work) {
    return (
      <h2 className="text-center mt-5 text-danger">⚠️ Project not found</h2>
    );
  }

  return (
    <main>
      {/* Hero */}
      <section
        style={{
          height: "100vh",
          backgroundImage: `url(${work.bgImage})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        {work.id === "02ec50f3" ? (
          <div className="container py-5 mt-5">
            <div className="row d-flex align-items-center justify-content-center m-auto">
              {/* Text on the right (Shows first on mobile) */}
              <div className="col-md-7 order-1 order-md-2">
                <h1 className="text-start" style={{ fontSize: "100px" }}>
                  {work.title}
                </h1>
                <p className="text-muted">{work.description}</p>
              </div>

              {/* Image on the left (Shows second on mobile) */}
              <div className="col-md-4 offset-md-1 order-2 order-md-1">
                <img
                  src={work.subImage}
                  alt={work.title}
                  className="img-fluid rounded mx-auto d-block"
                  style={{ maxWidth: "100%", height: "500px" }}
                />
              </div>
            </div>
          </div>
        ) : work.id === "025506e1" ? (
          <div className="container py-5 mt-5">
            <div className="row d-flex align-items-center justify-content-center m-auto">
              {/* Image on the left (Shows second on mobile) */}
              <div className="col-md-7 order-1 order-md-2">
                <img
                  src={work.subImage}
                  alt={work.title}
                  className="img-fluid rounded mx-auto d-block"
                  style={{ maxWidth: "100%", height: "500px" }}
                />
              </div>

              {/* Text on the right (Shows first on mobile) */}
              <div className="col-md-4 offset-md-1 order-2 order-md-1">
                <h1 className="text-start" style={{ fontSize: "100px" }}>
                  {work.title}
                </h1>
                <p className="text-muted">{work.description}</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div
              className="row d-flex align-items-center justify-content-center m-auto"
              style={{ height: "100vh" }}
            >
              <h1
                className="text-center display-1"
                style={{ fontSize: "500px" }}
              >
                {work.title}
              </h1>
            </div>
          </div>
        )}
      </section>

      <section className="container" style={{ margin: "80px auto" }}>
        {/* Project Overview */}
        {work.projectOverview && (
          <div className="container mt-5 mb-4 p-4 round-x1 shad-x1 border-0 bg-light">
            <div className="row">
              {/* Left side: Title */}
              <div className="col-md-6">
                <h3 className="text-black fw-semibold fs-5 fs-md-4 mb-3 mb-md-0">
                  {work.projectOverview.title}
                </h3>
              </div>

              {/* Right side: Description & Duration */}
              <div className="col-md-6">
                <p className="text-secondary fs-6 fs-md-5 lh-lg">
                  {work.projectOverview.description}
                </p>

                {work.projectOverview.duration && (
                  <p className="text-muted fs-6 fs-md-5">
                    <strong>Project Duration:</strong> <br />
                    <span className="d-block mt-3">
                      {work.projectOverview.duration}
                    </span>
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="mt-5 pt-5 text-center">
          <img src={work.largeImage} alt={work.title} className="img-fluid" />
          <p className="mt-2">Chill Pill responsive app and website</p>
        </div>

        {/* The Goal */}
        {work.goal && (
          <div className="container mt-5 mb-4 p-4round-x1 shad-x1 border-0 bg-light round-x1 shad-x1">
            <div className="row">
              {/* Left side: Goal Section */}
              <div className="col-md-6">
                <h3 className="fw-semibold fs-5 pt-4 fs-md-4 mb-3">
                  {/* Increased space below title */}
                  {work.goal.title}
                </h3>
                <p className="lh-lg">
                  {/* Increased line height */}
                  {work.goal.description}
                </p>
              </div>

              {/* The Problem */}
              <div className="col-md-6">
                <h3 className="fw-semibold fs-5 fs-md-4 mb-3 pt-4">
                  {/* Increased space below title */}
                  {work.problem.title}
                </h3>
                <p className="text-secondary fs-6 fs-md-5 lh-lg">
                  {/* Increased line height */}
                  {work.problem.description}
                </p>
              </div>
            </div>
          </div>
        )}

        {work.experiences && (
          <div className="container mt-4 p-4 round-x1 shad-x1 border-0 bg-light">
            <div className="row">
              {work.experiences.map((item, index) => (
                <div key={index} className="col-md-3">
                  <h5 className="fw-bold">{item.title}</h5>
                  {item.description.map((desc, i) => (
                    <p key={i} className="text-muted">
                      {desc}
                    </p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}

        {/*   My Design Process */}
        {work.steps && (
          <div className="container mt-5 bg-light round-x1 shad-x1">
            <h3 className="fw-bold text-center fs-1 pb-5 pt-5">
              My Design Process
            </h3>
            <div
              className="fw-bold d-flex flex-wrap justify-content-between align-items-center p-5"
              style={{
                flexDirection: "row",
              }}
            >
              {work.steps.map((step, index) => (
                <React.Fragment key={index}>
                  <div className="d-flex flex-column align-items-center">
                    <div
                      className="d-flex justify-content-center align-items-center border rounded-circle"
                      style={{
                        width: "80px",
                        height: "80px",
                        fontSize: "28px",
                        fontWeight: "bold",
                        transition: "0.3s",
                        cursor: "pointer",
                        borderColor: "black",
                      }}
                      onMouseEnter={(e) => {
                        (
                          e.currentTarget as HTMLDivElement
                        ).style.backgroundColor = "#6c757d"; // Gray background
                        (e.currentTarget as HTMLDivElement).style.color =
                          "white"; // White text
                      }}
                      onMouseLeave={(e) => {
                        (
                          e.currentTarget as HTMLDivElement
                        ).style.backgroundColor = "transparent";
                        (e.currentTarget as HTMLDivElement).style.color =
                          "black"; // Reset text color
                      }}
                    >
                      {step.number}
                    </div>
                    <p
                      className="mt-2 text-center"
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        maxWidth: "120px",
                      }}
                    >
                      {step.text}
                    </p>
                  </div>

                  {index < work.steps.length - 1 && (
                    <div
                      className="d-none d-lg-block flex-grow-1 mx-3"
                      style={{
                        height: "2px",
                        backgroundColor: "black",
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        {/* Understanding the user */}
        {work.understandingUser && (
          <div className="mt-5 text-start bg-light p-4 round-x1 shad-x1">
            <p className="fs-2 fw-bold">{work.understandingUser.title}</p>
            <ul className="fs-6">
              {work.understandingUser.description.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        {/* User research: summary */}
        {work.userResearch && (
          <div className="container mt-5 mb-4 p-4 round-x1 shad-x1 border-0 bg-light round-x1 shad-x1">
            <div className="row align-items-center">
              {/* Center content vertically */}
              {/* Left side: Goal Section */}
              <div className="col-md-6 text-start">
                <h3 className="fw-semibold fs-4 fs-md-4 mb-3">
                  {work.userResearch.title}
                </h3>
                <p className="lh-lg">{work.userResearch.description}</p>
              </div>
              {/* The Problem (Image) */}
              <div className="col-md-6 text-center">
                <img
                  src={work.userResearch.image}
                  alt="User Research"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    height: "500px",
                    objectFit: "cover",
                  }}
                />
                <p className="mt-2">Affinity Diagram</p>
              </div>
            </div>
          </div>
        )}

        {/* Personas */}
        {work.personas && (
          <div className="mt-5 col-md-8 text-start p-4">
            <p className="fs-4 fw-bold">{work.personas.title}</p>
            <span className="text-center text-md-start lh-lg fs-6">
              {work.personas.description}
            </span>
          </div>
        )}

        {/* Images */}
        {work.twoImages && (
          <div className="container mt-5 mb-5 p-4 round-x1 shad-x1 border-0 bg-light round-x1 shad-x1">
            <div className="row align-items-center">
              <div className="col-12 col-md-6 text-center mb-3 mb-md-0">
                <img
                  src={work.twoImages.image1}
                  alt="User Research"
                  className="img-fluid w-100 rounded"
                  style={{
                    height: "auto", // Maintain aspect ratio
                    maxHeight: "500px", // Limit max height on large screens
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="col-12 col-md-6 text-center">
                <img
                  src={work.twoImages.image2}
                  alt="User Research"
                  className="img-fluid w-100 rounded"
                  style={{
                    height: "auto",
                    maxHeight: "500px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {/* Personas */}
        {work.competitive && (
          <div className="mt-5 pt-5 col-md-8 text-start p-4">
            <p className="fs-4 fw-bold">{work.competitive.title}</p>
            <span className="text-center text-md-start lh-lg fs-6">
              {work.competitive.description}
            </span>
          </div>
        )}

        {/* Carousel */}
        <div style={{ paddingTop: "20px" }}></div>
        <ImageCarousel />

        {/* Ideation */}
        {work.ideation && (
          <div className="container mt-5 mb-4 p-4 round-x1 shad-x1 border-0 bg-light round-x1 shad-x1">
            <div className="row align-items-center">
              {/* Center content vertically */}
              {/* Left side: Goal Section */}
              <div className="col-md-6 text-start">
                <h3 className="fw-semibold fs-4 fs-md-4 mb-3">
                  {work.ideation.title}
                </h3>
                <p className="lh-lg">{work.ideation.description}</p>
              </div>

              {/* The Problem (Image) */}
              <div className="col-md-6 text-center">
                <img
                  src={work.ideation.image}
                  alt="User Research"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    height: "500px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Starting the design */}
        {work.startingTheDesign && (
          <div className="mt-5 text-start bg-light p-4 round-x1 shad-x1">
            <p className="fs-2 fw-bold">{work.startingTheDesign.title}</p>
            <ul className="fs-6">
              {work.startingTheDesign.description.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Digital wireframes */}
        {work.digitalWireframes && (
          <div className="container mt-5 mb-4 p-4 round-x1 shad-x1 border-0 bg-light round-x1 shad-x1">
            <div className="row align-items-center">
              {/* Center content vertically */}
              {/* Left side: Goal Section */}
              <div className="col-md-6 text-start">
                <h3 className="fw-semibold fs-4 fs-md-4 mb-3">
                  {work.digitalWireframes.title}
                </h3>
                <p className="lh-lg">{work.digitalWireframes.description}</p>
              </div>
              {/* The Problem (Image) */}
              <div className="col-md-6 text-center">
                <img
                  src={work.digitalWireframes.image}
                  alt="User Research"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    height: "500px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Low-fidelity prototype */}
        {work.lowFidelityPrototype && (
          <div className="container mt-5 mb-4 p-4 round-x1 shad-x1 border-0 bg-light round-x1 shad-x1">
            <div className="row align-items-center">
              {/* Center content vertically */}
              {/* Left side: Goal Section */}
              <div className="col-md-6 text-start">
                <h3 className="fw-semibold fs-4 fs-md-4 mb-3">
                  {work.lowFidelityPrototype.title}
                </h3>
                <p className="lh-lg">{work.lowFidelityPrototype.description}</p>
              </div>
              {/* The Problem (Image) */}
              <div className="col-md-6 text-center">
                <img
                  src={work.lowFidelityPrototype.image}
                  alt="User Research"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Usability study */}
        {work?.usabilityStudyData && (
          <div className="text-start bg-light p-4 round-x1 shad-x1">
            <h3>Usability Study: Parameters</h3>
            {work.usabilityStudyData.map((item, index) => (
              <div key={index}>
                <p className="fw-bold pt-5">{item.label}:</p>
                <span>{item.value}</span>
              </div>
            ))}
          </div>
        )}

        {/* Usability study: findings */}
        {work?.usabilityStudyFindingsSection && (
          <div className="text-start bg-light mt-5 p-4 round-x1 shad-x1">
            <div className="pt-5">
              <h3>{work.usabilityStudyFindingsSection.title}</h3>
              <p className="fs-6">
                {work.usabilityStudyFindingsSection.description}
              </p>
            </div>
          </div>
        )}

        {work?.usabilityStudyFindings && (
          <ul className="list-unstyled ps-4">
            {work.usabilityStudyFindings.map((finding, index) => (
              <li key={index} className="mb-3">
                <h5 className="fw-semibold mt-4">{finding.title}</h5>
                <p className="ps-4 fs-6">{finding.description}</p>
              </li>
            ))}
          </ul>
        )}

        {/* Refining the design */}
        {work.refiningTheDesign && (
          <div className="mt-5 text-start bg-light p-4 round-x1 shad-x1">
            <p className="fs-2 fw-bold">{work.refiningTheDesign.title}</p>
            <ul className="fs-6">
              {work.refiningTheDesign.description.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Mockups */}
        {work.mockups && (
          <div className="mt-5 pt-5 col-md-8 text-start p-4">
            <p className="fs-4 fw-bold">{work.mockups.title}</p>
            <span className="text-center text-md-start lh-lg fs-6">
              {work.mockups.description}
            </span>
          </div>
        )}

        {work.mockups && (
          <div className="mt-5 pt-5 col-md-12 text-start p-4">
            <div className="d-flex flex-column">
              <img
                src={work.mockups.image1}
                className="img-fluid mx-auto d-block"
                style={{
                  width: "100%",
                  maxWidth: "600px",
                  height: "300px",
                  objectFit: "cover",
                }}
                alt="Mockup 1"
              />
              <img
                src={work.mockups.image2}
                className="img-fluid mx-auto d-block mt-5"
                style={{
                  width: "100%",
                  maxWidth: "600px",
                  height: "400px",
                  objectFit: "cover",
                }}
                alt="Mockup 2"
              />

              {/* ✅ Align text to the start */}
              <p
                className="fs-4 fw-bold align-self-start"
                style={{ marginTop: "100px" }}
              >
                {work.mockups.title}
              </p>
            </div>
          </div>
        )}

        {/* High-fidelity prototype */}
        {work.highFidelityPrototype && (
          <div className="container mt-5 mb-4 p-4 border-0 bg-light round-x1 shad-x1">
            <div className="row align-items-center">
              {/* Center content vertically */}
              {/* Left side: Goal Section */}
              <div className="col-md-6 text-start">
                <h3 className="fw-semibold fs-4 fs-md-4 mb-3">
                  {work.highFidelityPrototype.title}
                </h3>
                <p className="lh-lg">
                  {work.highFidelityPrototype.description}
                </p>
              </div>

              {/* The Problem (Image) */}
              <div className="col-md-6 text-center">
                <img
                  src={work.highFidelityPrototype.image}
                  alt="User Research"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    height: "300px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Accessibility Considerations */}
        {work.accessibilityConsiderations && (
          <div className="mt-5 pt-5 col-md-12 text-start p-4">
            <h3 className="fw-bold mb-5">
              {work.accessibilityConsiderations.title}
            </h3>
            <ul className="list-unstyled mt-3 ps-5">
              {work.accessibilityConsiderations.points.map((point, index) => (
                <li key={index} className="mb-4">
                  {point}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Responsive design */}
        {work.responsiveDesign && (
          <div className="mt-5 text-start bg-light p-4 round-x1 shad-x1">
            <p className="fs-2 fw-bold">{work.responsiveDesign.title}</p>
            <ul className="fs-6">
              {work.responsiveDesign.description.map((item, index) => (
                <li key={index} className="mt-1">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Sitemap */}
        {work.sitemap && (
          <div className="container mt-5 mb-4 p-4 round-x1 shad-x1 bg-light">
            <div className="row align-items-center">
              {/* Left Side: Text Content */}
              <div className="col-md-6 text-start">
                <h3 className="fw-semibold fs-4 fs-md-4 mb-3">
                  {work.sitemap.title}
                </h3>
                <p className="lh-lg">{work.sitemap.description}</p>
              </div>

              {/* Right Side: Image */}
              <div className="col-md-6 text-center">
                <img
                  src={work.sitemap.image}
                  alt="Sitemap"
                  className="img-fluid "
                  style={{
                    width: "100%",
                    maxWidth: "500px", // Ensures a good size on larger screens
                    height: "auto", // Prevents distortion
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Responsive Designs */}
        <div className="container round-x1 shad-x1">
          {/* Title & Description */}
          {work.responsivedesigns && (
            <div className="row justify-content-center">
              <div className="col-md-8 text-start p-4">
                <p className="fs-4 fw-bold">{work.responsivedesigns.title}</p>
                <span className="text-start lh-lg fs-6">
                  {work.responsivedesigns.description}
                </span>
              </div>
            </div>
          )}

          {/* Responsive Images */}
          {work.responsivedesigns && (
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 text-start d-flex flex-column align-items-center">
                <img
                  src={work.responsivedesigns.image1}
                  className="img-fluid"
                  style={{
                    width: "100%",
                    maxWidth: "650px",
                    height: "auto", // Allow height to scale properly
                    objectFit: "cover",
                  }}
                  alt="Mockup1"
                />
                <img
                  src={work.responsivedesigns.image2}
                  className="img-fluid mt-4"
                  style={{
                    width: "100%",
                    maxWidth: "900px",
                    height: "auto", // Keep aspect ratio
                    objectFit: "cover",
                  }}
                  alt="Mockup2"
                />
              </div>
            </div>
          )}
        </div>

        {/* UsabilityTesting */}
        {work.usabilityTesting && (
          <div className="pt-5 mt-5 p-4 col-md-10 bg-light round-x1 shad-x1">
            <div>
              <h3 className="fw-semibold fs-4">
                {work.usabilityTesting.title}
              </h3>
              <p className="lh-lg fs-6 mt-5">
                {work.usabilityTesting.description}
              </p>

              {/* Loop through issues */}
              {work.usabilityTesting.issues.map((issue, index) => (
                <div key={index} className="mt-4 p-3">
                  {/* Findings Section */}
                  <h5 className="fw-bold">{issue.title}</h5>
                  <p className="fw-semibold mt-4">{issue.subtitle}</p>{" "}
                  {/* ✅ Subtitle added */}
                  <p className="lh-lg">{issue.findings}</p>
                  {/* Solution Section */}
                  <h5 className="fw-bold mt-3">{issue.solutionTitle}</h5>
                  <p className="fw-semibold mt-4">{issue.subtitle2}</p>{" "}
                  {/* ✅ Subtitle added */}
                  <p className="lh-lg">{issue.solution}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Responsive design */}
        {work.goingForward && (
          <div className="mt-5 text-start bg-light p-4 round-x1 shad-x1">
            <p className="fs-2 fw-bold">{work.goingForward.title}</p>
            <ul className="fs-6">
              {work.goingForward.description.map((item, index) => (
                <li key={index} className="mt-1">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Takeaway */}
        {work.takeaway && (
          <div className="pt-5 mt-5 p-4 col-md-10 bg-light round-x1 shad-x1">
            <div>
              <h3 className="fw-semibold fs-4">{work.takeaway.title}</h3>

              {/* Loop through issues */}
              {work.takeaway.issues.map((issue, index) => (
                <div key={index} className="mt-4 p-3">
                  {/* Findings Section */}
                  {/* <h5 className="fw-bold">{issue.title}</h5> */}
                  <p className="fw-semibold mt-3">{issue.subtitle}</p>{" "}
                  {/* ✅ Subtitle added */}
                  <p className="lh-lg">{issue.findings}</p>
                  {/* Solution Section */}
                  {/* <h5 className="fw-bold mt-3">{issue.solutionTitle}</h5> */}
                  <p className="fw-semibold mt-4">{issue.subtitle2}</p>{" "}
                  {/* ✅ Subtitle added */}
                  <p className="lh-lg mt-4">{issue.solution}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Next Steps */}
        {work.nextSteps && (
          <div className="mt-5 p-4 col-md-10 mx-auto bg-light text-center round-x1 shad-x1">
            <div>
              <h3 className="fw-semibold fs-4">{work.nextSteps.title}</h3>
              <div className="d-flex flex-column align-items-center mt-4">
                {work.nextSteps.steps.map((step) => (
                  <p key={step.id} className="lh-lg mb-3 fs-6 mt-5 w-75">
                    {step.description}
                  </p>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Learnings */}
        {work.learnings && (
          <div className="pt-5 mt-5 p-4 col-md-8 bg-light round-x1 shad-x1">
            <div>
              <h3 className="fw-semibold fs-4">{work.learnings.title}</h3>
              <p className="lh-lg fs-6 mt-4">{work.learnings.description}</p>
            </div>
          </div>
        )}

        {/* Thank you for reading my case study! */}
        {work.appreciationText && (
          <div className="pt-5 mt-5 p-4 col-md-8 bg-light round-x1 shad-x1">
            <div>
              <h3 className="fw-semibold fs-4">
                {work.appreciationText.title}
              </h3>
              <p className="lh-lg fs-6 mt-4">
                {work.appreciationText.description}
              </p>
              <div className="w-70">
                <p className="lh-lg fs-6 mt-4">
                  {work.appreciationText.moreInfo}
                </p>
                <p className="lh-lg fs-6">{work.appreciationText.more}</p>{" "}
                {/* Reduced margin */}
              </div>
            </div>
          </div>
        )}

        <footer className="py-4 bg-light mt-5 text-start px-4 round-x1 shad-x1">
          <p className="fs-6">Thanks for stopping by!</p>
          <p className="fs-6">Connect with me.</p>
          <div className="position-relative d-inline-block">
            <Link to="/contact">
              <button
                className="btn border-2"
                style={{
                  backgroundColor: "lightgray",
                  border: "2px solid gray",
                  borderRadius: "0",
                  width: "110px",
                  marginBottom: "30px",
                  color: "#000",
                }}
              >
                Here
              </button>
            </Link>
          </div>
        </footer>
      </section>
    </main>
  );
}

export default WorkDetails;
